import type { SignEventRequest, SignEventResponse } from '@ytl/common-model/lib/verificator-process-api';
import { AxiosResponse } from 'axios';
import { axiosInstance } from './axiosInstance';

export const verificatorResource = {
  /**
   * EMAIL VERIFICATION
   */

  /**
   * Send email verification code
   * @param data Request body with emailAddress and purpose
   */
  sendEmailVerificationCode(data: any, corrId?: string): Promise<AxiosResponse<any>> {
    return axiosInstance.post(`/api/verify/email/send-code`, data, {
      headers: corrId ? { 'msg-ctx-corr-id': corrId } : {},
    });
  },

  /**
   * Check email verification code
   * @param data Request body with sessionId and code
   */
  checkEmailVerificationCode(data: any, corrId?: string): Promise<AxiosResponse<any>> {
    return axiosInstance.post(`/api/verify/email/check-code`, data, {
      headers: corrId ? { 'msg-ctx-corr-id': corrId } : {},
    });
  },

  /**
   * Validate email address
   * @param data Request body with email and optional password
   */
  validateEmail(data: any, corrId?: string): Promise<AxiosResponse<any>> {
    return axiosInstance.post(`/api/verify/email/validate`, data, {
      headers: corrId ? { 'msg-ctx-corr-id': corrId } : {},
    });
  },

  /**
   * MSISDN VERIFICATION
   */

  /**
   * Send MSISDN verification code
   * @param data Request body with msisdn and purpose
   */
  sendMsisdnVerificationCode(data: any, corrId?: string): Promise<AxiosResponse<any>> {
    return axiosInstance.post(`/api/verify/msisdn/send-code`, data, {
      headers: corrId ? { 'msg-ctx-corr-id': corrId } : {},
    });
  },

  /**
   * Check MSISDN verification code
   * @param data Request body with sessionId and code
   */
  checkMsisdnVerificationCode(data: any, corrId?: string): Promise<AxiosResponse<any>> {
    return axiosInstance.post(`/api/verify/msisdn/check-code`, data, {
      headers: corrId ? { 'msg-ctx-corr-id': corrId } : {},
    });
  },

  /**
   * Validate MSISDN number
   * @param data Request body with msisdn
   */
  validateMsisdn(data: any, corrId?: string): Promise<AxiosResponse<any>> {
    return axiosInstance.post(`/api/verify/msisdn/validate`, data, {
      headers: corrId ? { 'msg-ctx-corr-id': corrId } : {},
    });
  },

  /**
   * VERIFICATION PROCESS (Authenticated)
   */

  /**
   * Start a verification process
   * @param data Request body with verification details
   */
  startVerificationProcess(data: any, corrId?: string): Promise<AxiosResponse<any>> {
    return axiosInstance.post(`/api/verify/start-process`, data, {
      headers: corrId ? { 'msg-ctx-corr-id': corrId } : {},
    });
  },

  /**
   * Sign verification event
   * @param data Request body with sessionId, eventName and isSuccess
   */
  signEvent(data: SignEventRequest, corrId?: string): Promise<AxiosResponse<SignEventResponse>> {
    return axiosInstance.post(`/api/verify/sign-event`, data, {
      headers: corrId ? { 'msg-ctx-corr-id': corrId } : {},
    });
  },

  /**
   * DUP ENTRY (Authenticated)
   */

  /**
   * Create a DUP (Data User Profile) entry
   * @param data Request body with DUP details
   */
  createDUPEntry(data: any, corrId?: string): Promise<AxiosResponse<any>> {
    return axiosInstance.post(`/api/dup/create`, data, {
      headers: corrId ? { 'msg-ctx-corr-id': corrId } : {},
    });
  },
};
